import React, { useContext, useEffect } from 'react';
import styles from '../Modal.module.scss';
import { ColumnLayoutProps } from '../shared-types';
import { ViewportSizeContext } from '../ViewportSizeContext';
import Footer from '../Footer';

export const TwoColumnLayout: React.FC<ColumnLayoutProps> = ({
  contentColumns,
  disclaimer,
  footerButtons,
  maxModalWidth,
}) => {
  const viewportSize = useContext(ViewportSizeContext);
  const bodyTextRef = React.useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!bodyTextRef.current) return;
    const ref = bodyTextRef.current;
    ref.addEventListener('scroll', () => {
      if (bodyTextRef.current) {
        const { scrollHeight, clientHeight } = bodyTextRef.current;
        if (clientHeight < scrollHeight) {
          bodyTextRef.current.classList.add(styles.scrollable);
        } else {
          bodyTextRef.current.classList.remove(styles.scrollable);
        }
      }
    });
    return () => {
      ref.removeEventListener('scroll', () => {});
    };
  }, []);

  return (
    <>
      <div className={styles.column}>{contentColumns[0]}</div>
      <div className={styles.column}>
        <div className={styles.bodyText} ref={bodyTextRef}>
          {contentColumns[1]}
        </div>
        <Footer
          {...{ disclaimer, footerButtons }}
          maxWidthMobile={maxModalWidth === 'mobile'}
          maxWidthSmallDesktop={maxModalWidth === 'desktop-sm'}
          smallViewport={viewportSize.isSmall}
        />
      </div>
    </>
  );
};

TwoColumnLayout.displayName = 'TwoColumnLayout';

export default TwoColumnLayout;
